import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { InvoiceRowGroup } from '../../model/invoice-row-group';
import { InvoiceRowGroupService } from '../../service/data/invoice-row-group.service';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';
import { standardCommand } from '../../../core/model/command';

@Component({
    selector: 'app-invoice-row-group-manager',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [CommandHandlerResolver, InvoiceRowGroupService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoiceRowGroupMultiSelectManagerComponent extends MultiselectObjectManagerComponentBase<InvoiceRowGroup> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: InvoiceRowGroupService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: CommandHandlerResolver,
    accountService: UserAccountService
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('InvoiceRowGroup');
    this.title = 'INVOICE_ROW_GROUP.INVOICE_ROW_GROUP';
    this.preferencesKey = 'invoice.invoice-row-group.list';
    this.allowOpenOnRowClick = true;
    this.allowNew = false;
    this.AddSubscription(
      accountService.current.subscribe(account => {
        this.allowNew = account.hasAccess(ModuleNames.Invoicing, Features.InvoiceRowGroup);
      })
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (!this.allowNew) {
      this.contextMenuDefinition = this.contextMenuDefinition.filter(item => item.commandId !== standardCommand.delete);
    }
  }
}
